const ML_ROUTING_STATUS_LABELS = {
  pass: "Pass",
  fail: "Fail",
  pending: "Pending",
};

/** API sends status as pass | fail | pending (string). */
export const formatMlRoutingStatus = (status) => {
  if (status === null || status === undefined || status === "") {
    return "-";
  }
  const normalized = String(status).trim().toLowerCase();
  if (ML_ROUTING_STATUS_LABELS[normalized]) {
    return ML_ROUTING_STATUS_LABELS[normalized];
  }
  return String(status);
};

const normalizeMlRoutingText = (value) => {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value).trim();
};

/** Each row includes reasons: [{ flag, reason }, ...]. */
export const formatMlRoutingFlagsAndReasons = (reasons) => {
  if (!Array.isArray(reasons) || reasons.length === 0) {
    return [];
  }
  const flagReasonPairs = [];
  reasons.forEach((entry) => {
    const flag = normalizeMlRoutingText(entry?.flag);
    const reason = normalizeMlRoutingText(entry?.reason);
    if (flag || reason) {
      flagReasonPairs.push({ flag, reason });
    }
  });
  return flagReasonPairs;
};

export const formatMlRoutingFlagReasonPreview = (pairs) => {
  if (!Array.isArray(pairs) || pairs.length === 0) {
    return "-";
  }
  const parts = pairs.map((pair) => {
    const flag = pair?.flag || "";
    const reason = pair?.reason || "";
    if (flag && reason) {
      return `${flag}: ${reason}`;
    }
    return flag || reason;
  }).filter(Boolean);
  return parts.length ? parts.join("; ") : "-";
};

export const mapMlRoutingApiRow = (item, index) => {
  const flagReasonPairs = formatMlRoutingFlagsAndReasons(item.reasons);
  const rowKey = item.tis_pk != null && item.tis_pk !== ""
    ? `tis-${item.tis_pk}`
    : `ml-routing-${item.workorder_id ?? "wo"}-${item.genista_id ?? "gb"}-${index}`;
  return {
    key: rowKey,
    customer_id: item.customer_id ?? "-",
    workorder_id: item.workorder_id ?? "-",
    genista_id: item.genista_id ?? "-",
    test: item.test ?? "-",
    status: formatMlRoutingStatus(item.status),
    flagReasonPairs,
    flagReasonPreview: formatMlRoutingFlagReasonPreview(flagReasonPairs),
  };
};

/** qc_records_ml/ returns { message, result: [...] }. */
export const extractMlRoutingResultList = (apiResponse = {}) => {
  if (Array.isArray(apiResponse.result)) {
    return apiResponse.result;
  }
  if (Array.isArray(apiResponse.results)) {
    return apiResponse.results;
  }
  return [];
};
